let AbstractGeocoder = require('./../abstractGeocoder');
let NominatimGeocodingItem = require('./nominatimGeocodingItem');
let axios = require('axios');

class NominatimGeocoder extends AbstractGeocoder {
   constructor(params) {
      super(params);
      this.params = params;
      this.url = params.url || " http://nominatim.openstreetmap.org/";
   }

   async geocode(location) {
      let self = this;
      let result = (await axios(self.url + "search?q=" + location + "&format=json")).data;
      let items = result.map((item) => {
         return new NominatimGeocodingItem(item);
      });
      return items;
   }

   async reverseGeocode(coordinates) {
      let self = this;
      let results = (await axios(self.url + "reverse?lat=" + coordinates[1]+"&lon="+coordinates[0] + "&format=json")).data;
      return results;
   }
}

module.exports = NominatimGeocoder;